import { forwardRef } from 'react'
import {
  TextInputField,
  TextInputFieldProps,
  ToggleInputField,
  ToggleInputFieldProps,
} from 'utoniq-ui'

import { useTranslation } from '@/core'
import { CellFrame } from '@/core/architecture'

export const TextInputCell = forwardRef(
  (
    {
      titleProps,
      textFieldProps,
      error,
      ...props
    }: Omit<TextInputFieldProps, 't'>,
    ref
  ) => {
    const { t } = useTranslation('consoleEventCreate')
    return (
      <CellFrame>
        <TextInputField
          titleProps={{
            display: 'flex',
            alignItems: 'center',
            variant: 'h5',
            color: 'text.primary',
            ...titleProps,
          }}
          textFieldProps={textFieldProps}
          ref={ref}
          {...props}
          error={error}
          t={t}
        />
      </CellFrame>
    )
  }
)

export const ToggleInputCell = forwardRef(
  ({ sx, ...props }: Omit<ToggleInputFieldProps, 't'>, ref) => {
    return (
      <CellFrame>
        <ToggleInputField
          {...props}
          inputRef={ref}
          sx={{
            px: 0,
            pt: 0,
            '&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
              bgcolor: 'primary.main',
            },
            ...sx,
          }}
        />
      </CellFrame>
    )
  }
)
